import angular from 'angular'

import { wrap } from 'lodash-es'
import { makeAND } from '../utils/bits'

angular
  .module('ggs.gallery')
  .factory('InstantModeManager', InstantModeManagerProvider)

function InstantModeManagerProvider(qh, DefineMethod) {
  return function InstantModeManager(
    properties,
    extFlow,
    readyStateManager
  ) {
    const sign = 'galleryMain::InstantModeManager'

    const manager = {
      wrapM: DefineMethod(sign)
    }

    manager.wrapM('init',
      qh.makeIf(
        makeAND(
          properties.key2get.instant_mode_until_ready,
          readyStateManager.getters.negate.isReady),
        qh.makeFlow(
          extFlow.instantMode,
          wrap(extFlow.lazyMode, readyStateManager.readyEmitter.on))))

    manager.wrapM('destroy',
      wrap(extFlow.lazyMode, readyStateManager.readyEmitter.off))

    return manager
  }
}
